
<template>
  <div class="wrapper" v-show="pageshow">
      <div class="customerCaseDetail" v-wechat-title="activityinfo.title">

      </div>
    <mt-popup
      class='width100'
      v-model="commentpopup"
      position="bottom">
      <i class="iconfont iconshibai close" @click="commentpopup=false"></i>
      <comment ref="comment"/>
    </mt-popup>
    <!-- <i style="bottom:180px" class="fixedbutton icontaolunqu iconfont" @click="getcomments()"></i> -->
   <!-- <i style="bottom:140px" class="fixedbutton iconfenxiang iconfont" @click="goshare()"></i> -->
    <audio  preload="auto" id="audio" :src="activityinfo.music" class="media-audio" loop autoplay ref="MusicPlay"></audio>
    <i v-if='activityinfo.music' ref='refName' id="musictest" v-on:click="musicbutton()" class="iconfont iconyinlemusic216 audiobutton" :class="musicTF==true?'rotate':''"></i>
    <div class="header">
      <div class="title">{{activityinfo.title}}</div>
      <div class="actdata">
        <ul class="ul">
          <li class="iconfont iconicon-test"><em>{{activityinfo.readcount}}</em></li>
          <li class="iconfont iconfenxiang"><em>{{activityinfo.sharecount}}</em></li>
          <li class="iconfont iconbianji"><em>{{activityinfo.signcount}}</em></li>
          <li class="iconfont icondianzan"><em>{{activityinfo.goodcount}}</em></li>
        </ul>
      </div>
    </div>
    <div class="actinfo">
      <ul>
        <li class="icon-user">
          <i class="iconfont iconVIP1" v-show="activityinfo.publisher.userlevel==2"></i>
          <div style="flex:1">《{{activityinfo.org}}》</div>
          <div class="mark" v-on:click="markuser">
            <span class="marktip" :class="markstatus==1?'unmarktip':''"><span v-if='markstatus==1'>取消</span>关注</span>
          </div>
        </li>
        <li class="icon-time">{{activityinfo.begindate}}至{{activityinfo.enddate}}</li>
        <li class="icon-address"><a :href="'http://api.map.baidu.com/geocoder?address='+activityinfo.areaname+activityinfo.address+'&output=html&src=活动圈'">
          <div class="address">{{activityinfo.provincename}}{{activityinfo.cityname}}{{activityinfo.areaname}}{{activityinfo.address}}</div></a>
          <div class="aui-arrow">
          </div>
        </li>
        <li class="icon-contact" v-if="(activityinfo.publisher.userlevel>0&&activityinfo.iscontact>0)||shareuser.contactway">
          <div @click="makephone(shareuser.contactway)" v-if="shareuser.contactway">{{shareuser.contactname}}{{shareuser.contactway}}&nbsp;</div>
          <div @click="makephone(activityinfo.publisher.contactway)" v-else>{{activityinfo.publisher.contactname}}{{activityinfo.publisher.contactway}}&nbsp;</div>
        </li>

        <!-- <li class="icon-contact" @click="makephone(shareuser.contactway)" v-if="shareuser.contactname">{{shareuser.contactname}}{{shareuser.contactway}}&nbsp;</li>

        <li class="icon-contact" @click="makephone(activityinfo.publisher.contactway)" v-else>{{activityinfo.publisher.contactname}}{{activityinfo.publisher.contactway}}&nbsp;</li> -->
        <a :href="'tel:'+makephonecall" id='call' style="display:none">一键拨号</a>
        <li class="icon-cost" v-if="activityinfo.price!=0">{{activityinfo.price}}</li>
        <li v-else class="icon-cost">免费</li>
      </ul>
    </div>
    <div class="details">
      <div class="details-content" v-html="activityinfo.content"></div>
    </div>
    <div style="display: flex;justify-content:center" v-if="wx_qrcode">
      <img :src="wx_qrcode" />
    </div>
    <p class="articledata">
      <span><i>阅读</i>{{activityinfo.readcount}}</span>
      <span><i>转发</i>{{activityinfo.sharecount}}</span>
      <span><i>赞</i>{{activityinfo.goodcount}}</span>
      <!-- <span class="org-r" @click="toreward('activity')"><i class='iconfont articlelike iconlihe'></i></span> -->
      <!--2020-04-25 取消打赏按钮显示 -->
      <span class="org-r" @click="getcomments()"><i class='iconfont articlelike icontaolunqu'></i></span>
      <span class="org-r" @click='likeactivity'><i :class="goodstuta=='1'?'iconaixin1':'iconaixin'" class='iconfont articlelike'></i></span>
    </p>
    <div class="divHeight"></div>
    <div class="sign" v-if="activityinfo.isshowlist==1">
      <div class="sign-title">已报名({{activityinfo.signcount}})</div>
      <div class="signarea" v-if="signlist.length>0">
        <ul class="signlist">
          <li  v-for='(item,index) in signlist'>
            <table cellpadding="0" border="0" cellspacing="0">
              <tbody>
                <tr>
                  <td style="width:50%;white-space:nowrap;overflow: hidden;text-overflow:ellipsis;line-height: 24px;">
                    <span>{{item.signname}}</span><span v-if="item.zw">（{{item.zw}}）</span>
                    <i class="iconchenggong iconfont signin" v-if="item.issignin==1"></i>
                    <i class="iconfont iconmingpian" @click="tousercenter(item.visitcardid)" v-if="item.openvisitcard=='!!!!!!!!!!!!!!!!'"></i>
                    <br/>
                    <span v-if="item.gs" style="color:#ababab;font-size: 13px;">
                      {{item.gs}}
                    </span>
                  </td>
                  <td style="width:50%;text-align:right;">{{item.signtime}}</td>
                </tr>
              </tbody>
            </table>
          </li>
          <!-- <li>
            <table cellpadding="0" border="0" cellspacing="0">
              <tbody>
                <tr>
                  <td style="width:62%;white-space:nowrap;overflow: hidden;text-overflow:ellipsis;">
                    <span>杨韬睿</span>
                  </td>
                  <td style="width:38%;text-align:right;">2019-09-14</td>
                 </tr>
              </tbody>
            </table>
          </li> -->
        </ul>
        <div class="button-block" @click="moresignlist">{{moretext}}</div>
      </div>
      <div v-else class="signarea" style="text-align: center;">目前没有人报名该活动！</div>

      <div style="padding:10px 15px;">
      <a href="javascript:void(0)">
      <button id="btn" v-on:click="triggsign" style="background:orange;font-size:18px;height:40px;line-height:40px;color:white;text-align:center;width:100%;border-radius:4px;border:0px;">我要报名</button></a>
      </div>

      <div class="support-author" v-if="1!=1"><!-- 打赏区 -->
        <div class="btn btn-pay" @click="toreward('activity')">加油支持</div>
      </div>
      <!-- <div class="ContentWrapper" v-if="reward.length>0">
        <div class="picbox">
          <div class="list_box">
            <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
              <li v-for="(item,index) in reward" class="flex" :class="index>0?'b-line':''">
                <div class="flex-user">
                  <img v-if="item.headerimg" :src="item.headerimg" alt="">
                  <img v-else src='../../assets/images/logo.jpg'>
                </div>
                <div class="flex-box">
                  <h2><span style="font-weight:bold;margin-right:3px">{{item.username}}</span><span>{{item.paytime}}</span></h2>
                  <p>加油了<span style="color:red">{{item.rewardamount}}元</span><span v-if='item.rewardtip'>，{{item.rewardtip}}</span><span v-else>。</span></p>
                </div>
              </li>
            </ul>
            <div v-if='loading' class="more"><mt-spinner :type="3"></mt-spinner><span style="margin-left:5px">加载中...</span></div>
          </div>
        </div>
      </div> -->

    </div>

    <div class="qrcode"  v-on:click="coverboxshow = true">
      <i class="iconfont iconerweima"></i>
    </div>

    <div id="msgbkg2" class="background" v-show="coverboxshow">
      <div class="coverbox">
        <div class="mpimg"><img src="../../assets/images/qrcode.jpg"></div>
        <div class="check">为了让您有更好的用户体验，建议您关注活动圈公众号<br/>长按二维码图片进行识别，点击"活动圈"即可关注活动圈公众号。</div>
        <div class="copybutt" v-on:click="coverboxshow = false">关闭</div>
      </div>
    </div>

    <!-- <div style="height:50px">
      <ul class="box">
        <li><router-link to="/activity/hotactivity" class=""><span>活动广场</span></router-link></li>
        <li style="background-color:#f39613" v-on:click='triggsign'><span>我要报名</span></li>
        <li v-on:click="goshare"><span>一键转发</span></li>
      </ul>
    </div> -->
    <div style="height:60px">
      <div class="footer">
        <dd @click="tohotactivity"><i class="iconfont iconshouye"></i><font>首页</font></dd>
        <dd :class="goodstuta==1?'goodstuta':''" @click="likeactivity"><i :class="goodstuta=='1'?'iconfont iconaixin2':'iconfont iconaixin'"></i><font v-if="activityinfo.goodcount">{{activityinfo.goodcount}}</font><font v-else>0</font></dd>
        <!--<dd @click="toreward('activity')"><i class="iconfont iconlihe"></i><font>赞赏</font></dd> -->
        <dd><i class="iconfenxiang iconfont" @click="goshare()"></i><font>转发</font></dd>
        <!--2020-04-25 取消打赏按钮显示 -->
        <div @click='triggsign' class="triggsign">我要报名</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { getactivityinfobyid } from "@/api/api";
import { ActivitygetShareInfo } from "@/api/api";
import { getactivitygoodstatus } from "@/api/api";
import { setactivitygood } from "@/api/api";
import { checkmark } from "@/api/api";
import { markuser } from "@/api/api";
import { unmarkuser } from "@/api/api";
import { setreadcountbyactivityid } from "@/api/api";
import { getsignlist } from "@/api/api";
import { getsignstatus } from "@/api/api";
import utils from '@/assets/js/utils';
import { setactivityshare } from "@/api/api";
import { getActReward } from "@/api/api";
import {mapGetters} from 'vuex';
import { MessageBox } from 'mint-ui';
import { mapActions } from "vuex";
import comment from "@/views/Comment/comment";
export default {
  components: {
    comment
  },
  data(){
    return{
      iswx:utils.others.isWeixinBrowser(),
      makephonecall:'',
      activityinfo:{publisher:'',goodcount:0},
      moretext:'更多报名列表',
      musicTF:false,
      playerlist:'',
      searchvalue:'',
      group: 0, // request param
      markstatus:0,
      selected: "1",
      goodstuta:'',
      signlist:[],
      signlistpage:1,
      rewardpage:1,
      pagesize:15,
      isloadmore:true,
      rewardloadmore:false,
      shareuser:{contactname:'',contactway:''},
      shareusercode:'',
      signstatus:'',
      goodbutton:false,
      loading:false,
      reward:[],
      commentpopup:false,
      pageshow:false,
      coverboxshow:false,
      wx_qrcode:''
    }
  },
  computed:{
    ...mapGetters({
      userinfo:'userInfo',
    }),
  },
  mounted(){
    console.log("123:"+location.pathname);
    var ispreview=''
    if(this.$route.query.ispreview) {
      this.showmsg=true
      ispreview=this.$route.query.ispreview
    }
    var shareuser=''
    if(this.$route.query.shareuser){shareuser=this.$route.query.shareuser;this.shareusercode=this.$route.query.shareuser}
    sessionStorage.setItem('invitecode', shareuser);
    getactivityinfobyid({ activityid: this.$route.query.activityid,ispreview:ispreview,shareuser:shareuser,env:2 }).then(res => {
      if(res.code==200){
        this.activityinfo = res.data;
        if(res.data.publisher==null){ this.activityinfo.publisher=this.shareuser}
        if(res.data.shareuser){
          this.shareuser=res.data.shareuser;
          this.$sensors.track('activity_view_source', {
            act_id: this.$route.query.activityid,
          	act_title:this.activityinfo.title,
            shareuser:this.shareuser.contactname
          });
        }
        this.fatherusercode=this.activityinfo.usercode;
        if(!shareuser){
           sessionStorage.setItem('invitecode', this.fatherusercode);
        }

        this.setwxshare(window.location.href,'')
        this.pageshow=true
        var that=this
        if(res.data.music){
          document.addEventListener("WeixinJSBridgeReady", function() {
             // Toast('1')
            document.getElementById("audio").play();
            this.musicTF = true
          }, false);
          // document.addEventListener('touchstart', function(){
          //     document.getElementById("audio").play();
          // }, false);
        }
        this.wx_qrcode = this.activityinfo.publisher.wx_qrcode;
        this.checkmark()
        this.getActReward()
        this.setreadcount()
      }
      else{
        this.MessageBox('活动不存在')
      }
    });
    this.getgoodstatus()
    this.getsignlist()
    this.getsignstatus()
    this.$sensors.use('PageLeave');
  },
  methods:{
    ...mapActions({
      userOut: "setSignOut"
    }),
     setwxshare(e,desc){
      let url=e
      let share=[];
      var abstract=this.activityinfo.abstract
      if(desc){abstract=desc}
      share['title']=this.activityinfo.title;
      share['desc']=abstract;
      share['shareimg']=this.activityinfo.logo;
      share['url']=url;
      share.callmethod=this.setShare;
      console.log(url);
      let wx=this.wxjsapi(url,share,"");
    },
    getsignstatus(){
      if(!this.userinfo.usercode){
        return;
      }
      getsignstatus({ activityid: this.$route.query.activityid,usercode:this.userinfo.usercode }).then(res => {
        if(res.code==200){
          this.signstatus=res.data
        }
      });
    },
    getsignlist(){
      getsignlist({ activityid: this.$route.query.activityid,page:this.signlistpage,pagesize:this.pagesize }).then(res => {
        if(res.code==200){
          if(res.data.length>0)
          {
            this.signlist=this.signlist.concat(res.data);
            this.moretext='加载更多'
          }
          if(res.data.length<this.pagesize){
            this.isloadmore=false;
            this.moretext='没有更多列表了'
          }
        }
      });
    },
    moresignlist(){
      if(this.isloadmore)
      {
        this.moretext='加载中'
        this.signlistpage++;
        this.getsignlist()
      }
    },
    setreadcount(){
      setreadcountbyactivityid({ activityid: this.$route.query.activityid }).then(res => {//增加浏览量
        if(res.code==200){
          this.activityinfo.readcount++
        }
      });
    },
    getgoodstatus(){
      if(!this.userinfo.usercode){
        return;
      }
      getactivitygoodstatus({ activityid: this.$route.query.activityid,usercode:this.userinfo.usercode }).then(res => {
        if(res.code==200){
          this.goodstuta=res.data.status
        }
      });
    },
    getcomments(){
      if(!this.userinfo.mobile){
        MessageBox({
          title: '未绑定手机号！',
          message: '为了有更好的用户体验，需要绑定手机号才能进行该操作',
          showCancelButton: true,
          confirmButtonText:'去绑定'
        }).then(action => {
            if(action == 'confirm'){
              this.$router.push('/account/wxauth');
            }
        });
        return;
      }
      this.$refs.comment.commenttype='activity'
      this.$refs.comment.keyid=this.$route.query.activityid
      this.$refs.comment.firstclick()
      this.commentpopup=true
    },
    checkplogin(){
      if(this.userinfo.usercode){
        return true
      }
      else{
        MessageBox({
          title: '提示',
          message: '未登录',
          showCancelButton: true,
          confirmButtonText:'去登录'
        }).then(action => {
            if(action == 'confirm'){
              this.toLogin();
            }
        });
      }
    },
    is_vip(){
      if(this.userinfo.userlevel>0){
        return true;
      }
      else{
        MessageBox({
          title: '提示',
          message: '您不是活动圈会员，暂不能使用该功能',
          showCancelButton: true,
          inputType:'text',
          closeOnClickModal:false,
          confirmButtonText:'去升级'
        }).then(action => {
            if(action == 'confirm'){
              this.$router.push('/user/membership');
            }
        });
        return false;
      }
    },
    checkmark(){
      if(!this.userinfo.usercode){
        console.log('用户未登录')
        return;
      }
      checkmark({ markuser:this.userinfo.usercode,publisher:this.activityinfo.usercode }).then(res => {
        if(res.code==200){
          this.markstatus=res.data.markstatus
        }
      });
    },
    markuser(){
      if(!this.checkplogin()){
        return;
      }
      if(!this.userinfo.mobile){
        MessageBox({
          title: '未绑定手机号！',
          message: '为了有更好的用户体验，需要绑定手机号才能进行该操作',
          showCancelButton: true,
          confirmButtonText:'去绑定'
        }).then(action => {
            if(action == 'confirm'){
              this.$router.push('/account/wxauth');
            }
        });
        return;
      }
      if(this.markstatus!=1){
        markuser({ markuser:this.userinfo.usercode,publisher:this.activityinfo.usercode }).then(res => {
          Toast(res.msg)
          if(res.code==200){
            this.markstatus=1;
            this.$sensors.track('setorgsub', {
              act_id: this.$route.query.activityid,
            	act_title:this.activityinfo.title,
            });
          }
        });
        return;
      }else{
        MessageBox({
          title: '提示',
          message: '确定取消关注？',
          showCancelButton: true,
        }).then(action => {
            if(action == 'confirm'){
              unmarkuser({ markuser:this.userinfo.usercode,publisher:this.activityinfo.usercode }).then(res => {
                Toast(res.msg)
                if(res.code==200){
                  this.markstatus=0;
                  this.$sensors.track('unsetorgsub', {
                    act_id: this.$route.query.activityid,
                  	act_title:this.activityinfo.title,
                  });
                }
              });
            }
        });
      }

    },
    likeactivity(){
      if(this.goodstuta=='1'){Toast('您已经点过赞了');return}
      sessionStorage.setItem("islike",1);
      if(!this.checkplogin()){
        return;
      }
      sessionStorage.removeItem("islike");
      if(this.goodbutton){return}
      this.goodbutton=true
      var type=''
      if(this.goodstuta=='1'){rettype='0'}
      else{type='1'}
      setactivitygood({ usercode:this.userinfo.usercode,activityid: this.$route.query.activityid,type:type,invitecode:this.shareusercode }).then(res => {
        if(res.code==200){
            this.goodstuta=type

            if(type=='1'){
              Toast('点赞成功')
              this.activityinfo.goodcount++
              this.$sensors.track('setactivitygood', {
                act_id: this.$route.query.activityid,
              	act_title:this.activityinfo.title,
                good_type:1
              });
            }
            else{
              Toast('取消点赞成功')
              this.activityinfo.goodcount--
              this.$sensors.track('setactivitygood', {
              	act_id: this.$route.query.activityid,
              	act_title:this.activityinfo.title,
                good_type:0
              });
            }
            this.goodbutton=false
        }
      });
    },
    setShare(){
      var usercode=''
      if(this.userinfo.usercode){usercode=this.userinfo.usercode}
      if(this.$route.query.shareuser){this.fatherusercode=this.$route.query.shareuser}
      setactivityshare({ activityid: this.$route.query.activityid,usercode:usercode,fatherusercode:this.fatherusercode }).then(res => {
        if(res.code==200){
          this.activityinfo.sharecount++
        }
      });
    },
      /* 暂停音乐并停止旋转
       */
    musicPause() {
      this.$refs.MusicPlay.pause();
      this.musicTF = false;
    },
    /**
     * 播放音乐并开始旋转
     */
    musicPlay() {
      this.$refs.MusicPlay.play();
      this.musicTF = true
    },
    musicbutton(){
      if(this.musicTF == true){
        this.musicPause()
      }else{
        this.musicPlay()
      }
    },
    triggsign(){
      var fatherusercode=''
      if(this.$route.query.shareuser){fatherusercode=this.$route.query.shareuser}
        //else{fatherusercode=this.activityinfo.usercode}
      this.$router.push('/activity/activityjoin?activityid='+this.$route.query.activityid+'&fatherusercode='+fatherusercode);
    },
    makephone(phone){
      if(!phone){
        Toast('暂无手机号！');return;
      }
      this.makephonecall=phone
      MessageBox({
        title: '提示',
        message: '是否拨打'+phone+'？',
        showCancelButton: true,
      }).then(action => {
          if(action == 'confirm'){
            document.getElementById('call').click();
            this.makephonecall=''
          }
      });

    },
    toLogin(){
      this.userOut()
      this.$router.push('/account/login');
    },
    tohotactivity(){
      this.$router.push('/activity/hotactivity');
    },
    tousercenter(usercode){
      Toast(usercode)
    },
    goshare(){
      if(this.activityinfo.isteam!=1){
        MessageBox('提示','当前活动未开启团队模式，无法使用一键转发功能，如需转发请点击右上角将它发送给朋友或者朋友圈')
        return;
      }
      if(!this.checkplogin()){
        return;
      }
      if(!this.userinfo.mobile){
        MessageBox({
          title: '未绑定手机号！',
          message: '为了有更好的用户体验，需要绑定手机号才能进行一键转发',
          showCancelButton: true,
          confirmButtonText:'去绑定'
        }).then(action => {
            if(action == 'confirm'){
              this.$router.push('/account/wxauth');
            }
        });
        return;
      }
      if(this.$route.query.ispreview&&this.activityinfo.status==0){
        MessageBox('提示','当前为临时链接，不能一件转发')
        return
      }
      //if(!this.is_vip()){return}
      ActivitygetShareInfo({ usercode: this.userinfo.usercode,activityid: this.$route.query.activityid }).then(res => {//一键转发
        if(res.code==200){
          MessageBox('提示提示','祝贺，该活动已经一键转发成你的联系方式，点击右上角将它发送给朋友或者朋友圈')
          this.shareuser.contactname=res.data.contactinfo.contactname
          this.shareuser.contactway=res.data.contactinfo.contactway
          this.shareusercode=this.userinfo.usercode
          this.wx_qrcode = res.data.wx_qrcode;
          console.log(this.wx_qrcode);
          this.setwxshare(window.location.origin+window.location.pathname+'?'+'activityid='+this.$route.query.activityid+'&shareuser='+ this.userinfo.usercode,res.data.customabstract)
          this.$sensors.track('setactivityshare', {
            act_id: this.$route.query.activityid,
          	act_title:this.activityinfo.title,
          });
        }
        if(res.code==10001){
          MessageBox({
            title: '提示',
            message: '暂无联系人信息，是否立即设置？',
            showCancelButton: true,
          }).then(action => {
              if(action == 'confirm'){
                this.$router.push('/article/userdata')
              }
          });
        }
      });

    },
    toreward(rewardtype){
      if(!this.iswx){
        MessageBox('提示','请在微信客户端操作');
        return;
      }
      if(!this.userinfo.openid){
        localStorage.setItem('loginStatus', false)
        this.$router.push({
          path: '/account/login',
          name: 'login',
          params: {
            logintype: 'wx',
          }
        })
        return;
      }
      this.$router.push({ path: '/reward', query: { keyid:this.$route.query.activityid,attrid:this.$route.query.activityid,rewardtype:rewardtype}})
    },
    getActReward(){
      this.rewardloadmore=false;
      getActReward({ activityid:this.$route.query.activityid,page:this.rewardpage,pagesize:this.pagesize }).then(res => {
        if(res.data.length>0)
        {
          this.reward=this.reward.concat(res.data);
          this.rewardloadmore=true;
        }
        this.loading = false;
      });
    },
    MessageBox(msg){
      MessageBox({
        title: '提示',
        message: msg,
        closeOnClickModal:false,
      }).then(action => {

      });
    },
    loadMore() {
      console.log('加载更多加油')
      if(this.rewardloadmore)
      {
        this.loading = true;
        this.rewardpage++;
        this.getActReward();
      }
    },
  },
  created() {

  }
};




</script>

<style lang="stylus" scoped>
.signin{
  font-size:13px;
  color:#32de8b;
  font-weight: 700;
}
.width100
  width: 100vw;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
.close
  cursor: pointer;
  position:absolute
  right: 10px;
  top:5px
  font-size: 20px;
  z-index:66
.aui-arrow {
    text-align: right;
    color: #394154;
    padding-right: 12px;
    position: relative;
    height: 20px;
    overflow: hidden;
    display: -webkit-box;
    display: box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-height: 20px;
}
.aui-arrow span{
    color:#9f9f9f;
    font-size:14px;
}
.aui-arrow:after {
    content: " ";
    display: inline-block;
    height: 8px;
    width: 8px;
    border-width: 1px 1px 0 0;
    border-color: #9f9f9f;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    position: relative;
    top: -2px;
    position: absolute;
    top: 50%;
    margin-top: -5px;
    right: 2px;
    border-radius: 1px;
}
*,:after,:before
  -webkit-box-sizing:border-box
  -moz-box-sizing:border-box
  box-sizing:border-box
  margin:0
  padding:0
.divHeight
  width: 100%;
  height: 10px;
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
.fixedbutton
  font-style: normal;
  position:fixed
  opacity 0.6
  width:30px
  height:30px
  font-size:23px
  text-align:center
  right: 10px;
  z-index: 999;
  line-height:30px
  background-color: black;
  border-radius: 100%;
  color: white;
.audiobutton
  position:fixed
  opacity 0.6
  font-size:30px
  right: 10px;
  top: 10px;
  z-index: 999;
  line-height:30px
.rotate
  animation:4s linear infinite CDturn;  /*开始动画后无限循环，用来控制rotate*/
@keyframes CDturn{
from{transform:rotate(0deg)}
to{transform:rotate(360deg)}
}
ul,li
  list-style:none
.wrapper
  // position fixed
  width 100%
  height 100vh
  overflow:scroll
  background-color #fff
  .sign
    background: #fff;
    margin-bottom: 13px;
    .sign-title
      padding: 12px 15px;
      border-bottom: 1px solid #e6e6e6;
      font-weight: bolder;
      font-size: 14px;
    .signarea
      font-size: 13px;
      padding: 5px 15px;
      border-bottom: 1px solid #e6e6e6;
      .signlist
        line-height: 36px;
        margin: 0;
        padding:5px
        table
          margin-bottom: 10px;
          border-collapse: collapse;
          display: table;
          width: 100%!important;
          table-layout: fixed;
      .button-block
        padding: 10px 0 10px 0;
        margin-bottom: 0px;
        background: #f0f0f0;
        width: 100%;
        text-align: center;
        cursor: pointer;
  .details
    background: #fff;
    width:100%
    .details-content
      padding: 15px;
      overflow: hidden;
      //font-size:0 !important
      >>>*
        max-width: 100%;
      >>>section
        //font-size:0
      >>>p
        font-size:initial
   .articledata
      padding:0 10px 0 20px
      color: rgba(0,0,0,0.3);
      font-size:15px
      margin:0
      line-height:44px
      span
        margin-right 5px
        i
          font-style: normal;
      .org-r
        float:right
        text-align:center
        padding:0 10px
        height:44px
        margin:0
        .articlelike
          color:#fe4034
  .actinfo
    font-size 13px
    ul
      line-height: 36px;
      margin: 0;
      padding: 0;
      li
        display:flex
        align-items: center;
        padding: 12px 15px;
        border-top: 1px solid #e6e6e6;
        margin-bottom: 0;
        background-position: 16px;
        background-size: 20px 20px;
        background-repeat: no-repeat;
        padding-left: 50px;
        line-height: 22px;
        position: relative;
        a
          color:#000
          width:100%
        .address
          width: 90%;
        .iconVIP1
          color: #f2cb51;
        .mark
          //position: absolute;
          //right: 15px;
          top: 12px;
          .marktip
            box-sizing: border-box;
            color: #ff4823;
            border: 1px solid #ff4823;
            text-align: center;
            border-radius: 3px;
            padding: 1px 3px;
            margin-left: 10px;
            font-size: 14px;
          .unmarktip
            color: #999;
            border: 1px solid #999;
      .icon-time
        background-image: url(../../assets/images/icon-time.png);
      .icon-address
        display: flex;
        align-items: center;
        position: relative;
        background-image: url(../../assets/images/icon-address.png);
      .icon-rule
        background-image: url(../../assets/images/icon-info.png);
      .icon-contact
        background-image: url(../../assets/images/icon-contact.png);
      .icon-user
        background-image: url(../../assets/images/icon-user.png);
      .icon-cost
        background-image: url(../../assets/images/icon-cost.png);
  .header
    .title
      padding 20px 15px 0px 15px;
      font-size 24px;
      font-weight bold;
      color #000;
      line-height 34px;
    .actdata
      padding 0px 15px 6px 15px;
      //border-bottom 1px solid #e6e6e6;
      .ul
        line-height 36px;
        margin  0;
        padding  0;
        li
          margin-bottom 0;
          display  inline-block;
          font-size 13px;
          color #ababab;
          margin-right 8px;
          height 40px;
          line-height 40px;
          em
            font-style:normal
            margin-left: 3px;
   .box
      position: fixed;
      z-index: 200;
      bottom: 0;
      left: 0;
      width: 100%;
      display: -webkit-box;
      display: -moz-box;
      -webkit-box-orient: horizontal;
      -moz-box-orient: horizontal;
      -webkit-box-sizing: border-box;
      margin: 0px;
      padding: 0px;
      list-style-type: none;
      li
        border-left: 1px solid #fff;
        height: 45px;
        border-bottom: 0;
        border-right: 0;
        position: relative;
        -webkit-box-shadow: inset 0 0 3px #fff;
        float: left;
        width: 33.3333333%;
        margin: 0px;
        padding: 0px;
        text-align: center;
        font-size: 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        display: block;
        line-height: 45px;
        background-color: #78B0E8;
        color: #ffffff;
        a
          text-decoration: none;
          color: #ffffff;
  .support-author
    padding: 10px 0;
    text-align: center;
    clear: both;
    .btn
      display: inline-block;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857;
      border-radius: 4px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    .btn-pay
      //margin-bottom: 20px;
      padding: 8px 25px;
      font-size: 16px;
      color: #fff;
      background-color: #ea6f5a;
      border-radius: 20px;
  .ContentWrapper
      margin-right: auto;
      margin-left: auto;
      padding: 10px;
      max-width: 708px;
      .picbox
        border: 1px solid #ddd;
        padding: 10px;
        border-radius: 14px;
        background-color: #ffffff;
        box-shadow: 0 3px 4px #ddd;
        color:#8f8f8f
        font-size 15px;
        .list_box
          margin:0
          .more
            display flex
            text-align: center;
            margin:0 auto
            width: fit-content;
            span
              line-height: 28px
              font-size 16px;
          .b-line
            border-top: solid 1px #ddd;
          .flex
            display: flex;
            //align-items: center;
            padding:15px 5px;
            position: relative;
            .flex-user
              width: 40px;
              height: 40px;
              margin-right: 13px;
              img
                width: 40px;
                height: 40px;
                display: block;
                border: 1px solid #d6d6d6;
                border-radius: 100%;
            .flex-box
              -webkit-box-flex: 1;
              -webkit-flex: 1;
              flex: 1;
              min-width: 0;
              font-size: 14px;
              h2
                display: flex;
                font-size: 14px;
                margin-bottom: 6px;
                span:first-child
                  flex:1
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
              p
                font-size: 15px;
                margin:0
                color:#000
            .user-btn
              background: #49be39;
              border-radius: 3px;
              color: #fff;
              font-size: 14px;
              border: 1px solid #49be39;
              outline: none;
              width: 70px;
              text-align: center;
              height: 33px;
              line-height: 33px;
            .user-info
              border: 1px solid #d5d5d5;
              background: #fff;
              color: #888888;
        .center
          text-align: center;
        p
          margin: 0 0 10px;
        img
          max-width: 100%;
          height: auto;
          border: 0;
          -ms-interpolation-mode: bicubic;
          vertical-align: middle;
  .footer
    border-top: #ddd solid 2px;
    background: #fff;
    align-items: center;
    padding:5px 10px 5px 0
    position:fixed
    z-index:99
    bottom:0
    left:0
    right:0
    width:100%
    display:flex
    dd
      padding:0 20px
      text-align: center;
      overflow: hidden;
      color: #333333;
      font
        display: block;
        padding-top: 2px;
      i
        width: 24px;
        height: 24px
        font-size:24px
        max-width: 100%;
        border: 0;
        -ms-interpolation-mode: bicubic;
        vertical-align: middle;
    .triggsign
      font-size:16px
      text-align:center
      padding:8px 0
      flex:1
      background-image: linear-gradient(-90deg, #0fb94f 0%, #32de8b 100%);
      border-radius: 100px;
      color:#fff
    .goodstuta
      color:#fe4034 !important
a {
    text-decoration: none;
    color: #08acee;
}

button {
    outline: 0;
}

img {
    border: 0;
}

button,input,optgroup,select,textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
}

li {
    list-style: none;
}

a {
    color: #666;
}

.clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
}
div, dl, dt, dd, ol, ul, li, h1, h2, h3, h4, h5, h6, p, blockquote, pre, button, fieldset, form, input, legend, textarea, th, td {
    margin: 0;
    padding: 0;
}

.background
    transition: opacity 0.15s linear
    z-index:2099
    position: fixed;
    top:0
    bottom:0
    left:0
    right:0
    background-color:rgba(0,0,0,0.3)
    display:flex
    align-items:center
    .coverbox
      word-break: break-word;
      text-align: center;
      transition: 0.15s ease-out;
      margin:0 auto
      border-radius: 10px;
      background-color: #fff;
      width: 80%;
      padding:20px
      .mp
        line-height: 36px;
        font-size: 20px;
      .mpimg
        width:150px
        height:150px
        margin:0 auto
        img
          width:100%
          height:100%
.opacity
  opacity: 0;

.qrcode
		z-index: 10;
		position: fixed;
		right: 10px;
		bottom: 130px;
		width: 34px;
		height: 34px;
		border-radius: 50%;
		transform: translateZ(0);
		-webkit-transform: translateZ(0);
		background-color: rgba(0,0,0,.5);
		display: flex;
		justify-content: center;
		align-items: center;
		.iconfont
			font-size: 18px;
			color: #fff;
			z-index: 100;
.check
  transition: 0.3s ease-out;
  padding:10px 0
  margin-top:15px
  font-size: 14px;
.copybutt
  transition: 0.1s ease-out;
  background:rgba(81, 203, 238, 1);
  text-decoration:none;
  width:100%
  color:white;
  line-height:42px
  border-radius:3px;
  //cursor: pointer;
  font-size: 16px;
  margin: 0 auto
  margin-top:15px;
  height: 42px;
.buttnhidden
  width:0px
  overflow:hidden
</style>



// WEBPACK FOOTER //
// src/views/Activity/activityview.vue